import { ManufacturesDefaultDetails } from "../../../Constants/constant";
import { const_var, params } from "../../../redux/reducers/reducer";
import { selectOverhangBOBCase } from "../../extra_options_pricing/overhangPricing";
import { findWainscotTexture, setWainscotDefault } from "../building_color/wainscotColor.helper";
import centerBuildingsWallOptionsHelpers from "../building_wall/centerBuildingsWallOptions.helpers";
export function initBuildingSidingMaterialOptions(state, action) {
	const {
		sidingData,
		buildingData: { building }
	} = action;
	building.forEach((b) => {
		state.c_m_a[1].side_end_details = sidingData;
	});
}
export function getSidingOrientationOptions() {
	return [
		{ value: "horizontal", label: "Horizontal" },
		{ value: "vertical", label: "Vertical" }
	];
}
export function getDefaultMetalSiding() {
	return {
		name: "metal",
		label: "Metal",
		price_type: "$",
		price_of: [],
		panel_price_from: ["vertical"],
		panel_orientation: ["horizontal", "vertical"],
		orientation: "horizontal",
		cost: 0
	};
}

export function setBuildingSidingMaterialOptions() {
	const defaultMetal = getDefaultMetalSiding();
	let apiOptions = const_var.c_m_a?.[params.p_b_t]?.side_end_details || [];
	const_var.mainSidingOptions = Array.isArray(apiOptions) ? [...apiOptions] : [];
	const hasMetal = const_var.mainSidingOptions.some((item) => item?.name?.toLowerCase().includes("metal"));
	if (!hasMetal) {
		const_var.mainSidingOptions.unshift(defaultMetal);
	}
	const_var.sidingOptions = const_var.mainSidingOptions.map((item) => ({
		label: item.label,
		value: item.name
	}));
	let selectedName = const_var.selSidingOption;
	if (selectedName) {
		let matched = const_var.mainSidingOptions.find((item) => item.name === selectedName);
		if (!matched && selectedName.toLowerCase().includes("metal")) {
			matched = const_var.mainSidingOptions.find((item) => item?.name?.toLowerCase().includes("metal"));
		}
		if (matched) {
			const_var.selSidingObj = matched;
			const_var.selSidingOption = matched.name;
			return;
		}
	}
	let defaultSet = const_var.mainSidingOptions.find((item) => item?.name?.toLowerCase().includes("metal"));

	defaultSet = defaultSet || const_var.mainSidingOptions[0];

	const_var.selSidingObj = defaultSet;
	const_var.selSidingOption = defaultSet.name;
}
const getMateriallById = (material, id) => {
	return material?.find((mat) => mat.materialSubTypeId === id) || null;
};

export function setDefaultBuildingMaterialById(side_materials, selectedBuilding) {
	if (!side_materials || !selectedBuilding) return;

	const materialData = getMateriallById(side_materials, selectedBuilding.siding_material);

	if (materialData) {
		const_var.selSidingObj = materialData;
		const_var.selSidingOption = materialData?.name;
		const materialName = materialData?.name?.toLowerCase();
		params.wallTexture = materialName === "metal" ? "none" : materialData?.name;
		if (selectedBuilding?.wainscot_color) {
			params.wainscotTexture = materialName === "metal" ? "none" : materialData?.name;
		}
		params.wallOrientation = selectedBuilding?.is_vertical ? "vertical" : "horizontal";
	}
}

export const handleAllVerticalChange = (state, action,utils) => {
	let renderVerticalData = "";

	let selectedSidingObject = action.key != undefined ? const_var.mainSidingOptions.find((obj) => obj.name == action.key) : const_var.selSidingObj;
	if (action.makeValueChange != undefined /* && action.makeValueChange == true */) {
		state.params.wallOrientation = action.makeValueChange;
		const_var.isInsulationPriceManualChange = true;
	} else {
		const_var.isInsulationPriceManualChange = false;
	}
	if (action.key != undefined && action.key != "metal") {
		state.params.p_v_w = selectedSidingObject?.panel_price_from == "vertical";
	}
	if (action.key != undefined && action.key == "metal") {
		state.params.p_v_w = action.makeValueChange == "vertical";
	}

	if (action.key != "metal" && const_var.TypeEnum[state.params.p_r_s] == "Regular" && params.m_s_n != 12) {
		state.params.p_v_w = false;
		state.params.wallOrientation = "horizontal";
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "RegularRoofStyle";
		renderVerticalData = "state.isFullyEnclosedChecked" + state.params.p_v_w + state.const_var.isShowAlert;
	} else if (action.key != undefined && action.key != "metal" && const_var.TypeEnum[state.params.p_r_s] == "Regular") {
		state.params.p_v_w = false;
		state.params.wallOrientation = "horizontal";
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "RegularRoofStyle";
		renderVerticalData = "state.isFullyEnclosedChecked" + state.params.p_v_w + state.const_var.isShowAlert;
	} else {
		state.const_var.isShowAlert = false;
		renderVerticalData = "state.isFullyEnclosedChecked" + state.params.p_v_w + state.const_var.isShowAlert;
		centerBuildingsWallOptionsHelpers.applyAllVerticalWalls(state);
	}

	if ((state.params.p_r_s != 3 || (!state.params.p_v_w && state.params.p_r_s == 3)) && ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId) {
		state.params.p_f_i = false;
		state.params.p_r_o = state.params.p_r_s == 3 ? state.params.p_r_o : false;
		state.params.p_c_i = false;
	}
	if (action.key != undefined && state.const_var.isShowAlert == false) {
		state.const_var.selSidingOption = action.key;
		state.const_var.selSidingObj = selectedSidingObject;

		if (action.makeValueChange == undefined) {
			let panelOrinetation = state.const_var.sidingOrientationOptions;
			if (state.const_var.selSidingObj?.panel_orientation != undefined && state.const_var?.selSidingOption != "metal") {
				panelOrinetation = [];
				if (state.const_var.selSidingObj.panel_orientation.length != 0) {
					state.const_var.selSidingObj.panel_orientation.map((obj, idx) => {
						panelOrinetation.push({
							value: obj,
							label: obj
						});
					});
				}
				state.const_var.sidingOrientationOptions = panelOrinetation;
				state.params.wallOrientation = panelOrinetation && panelOrinetation.length > 0 ? panelOrinetation[0].value : "";
			} else if (state.const_var.selSidingObj.panel_orientation == undefined && state.const_var.selSidingOption != "metal") {
				state.params.wallOrientation = state.const_var.selSidingOption.includes("horizontal") ? "horizontal" : state.const_var.selSidingOption.includes("vertical") ? "vertical" : "";
			}
			if (state.const_var.selSidingOption == "metal") {
				state.const_var.sidingOrientationOptions = getSidingOrientationOptions();
			}
		}
	}
	if (action.key != undefined && action.key != "metal" && state.const_var.isShowAlert == false) {
		state.params.wallTexture = utils.sidingNameUpdateForWallTexture(action.key);
	} else if (action.key != undefined && action.key == "metal" && state.params.p_v_w == true && state.const_var.isShowAlert == false) {
		state.params.wallTexture = "vertical";
		state.params.wallOrientation = "vertical";
	} else {
		state.params.wallTexture = "none";
		state.params.wallOrientation = "horizontal";
	}

	if (const_var.isLTBuilding) {
		Object.keys(const_var.lNTBuildingData.extraAddOnItemsArray).map((key) => {
			if (const_var.lNTBuildingData.extraAddOnItemsArray[key] && const_var.lNTBuildingData.extraAddOnItemsArray[key]?.length > 0) {
				const_var.lNTBuildingData.extraAddOnItemsArray[key].forEach((obj, idx) => {
					if (obj && obj.siding_orientation && obj.siding_orientation != "both" && obj.siding_orientation != state.params.wallOrientation) {
						const_var.lNTBuildingData.extraAddOnItemsArray[key].splice(idx, 1);
					}
				});
			}
		});
	} else {
		if (const_var.extraAddOnItemsArray?.length > 0) {
			const_var.extraAddOnItemsArray.forEach((obj, idx) => {
				if (obj?.siding_orientation && obj.siding_orientation != "both" && obj.siding_orientation != state.params.wallOrientation) {
					const_var.extraAddOnItemsArray.splice(idx, 1);
				}
			});
		}
	}

	let tempSidingColorObj = state.const_var.color.filter((val) => val.sheet_name != undefined && val.sheet_name.toLowerCase() == state.const_var.selSidingOption.toLowerCase());
	if (tempSidingColorObj.length > 0) {
		let isSelWallClrExsist = tempSidingColorObj.find(
			(val) => val.sheet_name != undefined && val.sheet_name.toLowerCase() == state.const_var.selSidingOption.toLowerCase() && state.params.p_w_c == val.hex_value.replace("#", "0x")
		);

		state.params.p_w_c_name = isSelWallClrExsist != undefined && isSelWallClrExsist.name ? isSelWallClrExsist.name : tempSidingColorObj[0].name;
		state.params.p_w_c = isSelWallClrExsist != undefined && isSelWallClrExsist.hex_value ? isSelWallClrExsist.hex_value.replace("#", "0x") : tempSidingColorObj[0].hex_value.replace("#", "0x");
		state.params.p_w_c_id = isSelWallClrExsist != undefined && isSelWallClrExsist.id ? isSelWallClrExsist.id : tempSidingColorObj[0].id;
		let colorObj = isSelWallClrExsist != undefined ? isSelWallClrExsist : tempSidingColorObj[0];
		if (tempSidingColorObj != undefined && colorObj.image_name) {
			params.wallTexture = utils.sidingNameUpdateForWallTexture(colorObj.image_name.split(".")[0]);
			const_var.selSidingOption = colorObj.sheet_name;
			if (params.wallTexture == "none" || params.wallTexture == "vertical") const_var.selSidingOption = "metal";
		}

		state.const_var.post_data.building.wall_color_price = 0;
		state.const_var.UpdatedPriceData.wall_color_price_changed = true;

		let isSelWainscotClrExsist = tempSidingColorObj.find(
			(val) => val.sheet_name != undefined && val.sheet_name.toLowerCase() == state.const_var.selSidingOption.toLowerCase() && state.params.p_w_c_c == val.hex_value.replace("#", "0x")
		);
		state.params.p_w_c_c_name = isSelWainscotClrExsist != undefined && isSelWainscotClrExsist.name ? isSelWainscotClrExsist.name : tempSidingColorObj[0].name;
		state.params.p_w_c_c = isSelWainscotClrExsist != undefined && isSelWainscotClrExsist.name ? isSelWainscotClrExsist.hex_value.replace("#", "0x") : tempSidingColorObj[0].hex_value.replace("#", "0x");
		state.params.p_w_c_c_id = isSelWainscotClrExsist != undefined && isSelWainscotClrExsist.id ? isSelWainscotClrExsist.id : tempSidingColorObj[0].id;
		let wainscotColorObj = isSelWainscotClrExsist != undefined ? isSelWainscotClrExsist : tempSidingColorObj[0];
		params.wainscotTexture = tempSidingColorObj != undefined ? findWainscotTexture(wainscotColorObj) : params.wallTexture;
		if (tempSidingColorObj != undefined && wainscotColorObj.image_name) {
			params.wallTexture = utils.sidingNameUpdateForWallTexture(wainscotColorObj.image_name.split(".")[0]);
			params.wainscotTexture = params.wallTexture;
			const_var.selSidingOption = wainscotColorObj.sheet_name;
			if (params.wallTexture == "none" || params.wallTexture == "vertical") const_var.selSidingOption = "metal";
		}
		if (state.params.p_w_c_n == true) {
			state.const_var.post_data.building.wainscot_color_price = 0;
			state.const_var.UpdatedPriceData.wainscot_color_price_changed = true;
		}

		if (const_var.crmSetting.is_Edit != true && params.m_s_n == "122" && action.key != undefined && action.key.includes("board_and_batten")) {
			selectOverhangBOBCase(state);
		}
	}

	if (state.c_m_a[params.p_b_t]?.wainscot_details?.length > 0) {
	setWainscotDefault(state.c_m_a, params, state.const_var.color);
	}

	return {
		...state,
		newColor: renderVerticalData + action.key + new Date()
	};
};
